import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import mapActivityLogEntry from "slices/activityLog/mapActivityLogEntry";

const ACTIVITY_URL = "/api/activity/summary/log";
const PROPOSALS_AREA = "PROPOSALS";

export const fetchProposalActivityFeed = createAsyncThunk(
  "proposalActivity/fetchFeed",
  async () => {
    const { data } = await localhost.get(ACTIVITY_URL);
    return data.rows
      .filter((entry) => entry.area === PROPOSALS_AREA)
      .map(mapActivityLogEntry);
  }
);
